import styled from 'styled-components';
import { breakpoints, radius as radii, spacing, scrollMargin, containerWidths } from '../../styles';
export const Container = styled.div.withConfig({
  displayName: "grid__Container",
  componentId: "sc-1yrlhnn-0"
})(["margin-left:auto;margin-right:auto;padding-left:1rem;padding-right:1rem;width:100%;@media (min-width:", "px){max-width:", "px;}@media (min-width:", "px){max-width:", "px;}@media (min-width:", "px){max-width:", "px;}@media (min-width:", "px){max-width:", "px;}"], breakpoints.sm, containerWidths.sm, breakpoints.md, containerWidths.md, breakpoints.lg, containerWidths.lg, breakpoints.xl, containerWidths.xl);
export const Row = styled.div.withConfig({
  displayName: "grid__Row",
  componentId: "sc-1yrlhnn-1"
})(["", " ", " display:flex;flex-wrap:wrap;margin-left:-1rem;margin-right:-1rem;"], ({
  verticalAlign = 'stretch'
}) => {
  switch (verticalAlign.toLowerCase()) {
    case 'top':
      return 'align-items: flex-start;';

    case 'bottom':
      return 'align-items: flex-end;';

    case 'center':
      return 'align-items: center;';

    default:
      return 'align-items: stretch;';
  }
}, ({
  align = 'left'
}) => {
  switch (align.toLowerCase()) {
    case 'center':
      return 'justify-content: center;';

    case 'right':
      return 'justify-content: flex-end;';

    default:
      return 'justify-content: flex-start;';
  }
});
export function isColumnProperties(properties) {
  return !!properties; // TODO: check properties is actually UiColumnProperties;
} //up to 5 decimals in percentage widths for webkit (eg 7 => 58.333333%)

function spanWidth(span) {
  const regex = RegExp(/^-?\d+(?:\.\d{0,5})?/);
  const percentage = regex.exec((parseInt(span) * 100 / 12).toString());
  return percentage ? `${percentage[0]}%` : 'auto';
}

function breakpointToCSS({
  align,
  offset,
  push,
  order,
  span,
  top,
  bottom,
  left,
  right,
  radius
}) {
  const css = [];

  if (align) {
    css.push(`text-align: ${align};`);
  }

  if (offset) {
    css.push(`margin-left: ${spanWidth(offset)};`);
  }

  if (push) {
    css.push(`left: ${spanWidth(push)};`);
  }

  if (order) {
    css.push(`order: ${order};`);
  }

  if (span) {
    css.push(`
      flex: 0 0 auto;
      width: ${spanWidth(span)}; 
    `);
  }

  if (top) {
    if (top.substr(0, 1) === '-') {
      //z-index added to keep negative-margin div on top (eg UIPriceCards on /gold)
      css.push(`
        margin-top: -${spacing[top.substr(1)]};
        z-index: 1;
      `);
    } else {
      css.push(`padding-top: ${spacing[top]};`);
    }
  }

  if (bottom) {
    //z-index added to keep negative-margin div on top (eg UIPriceCards on /gold)
    if (bottom.substr(0, 1) === '-') {
      css.push(`
        margin-bottom: -${spacing[bottom.substr(1)]};
        z-index: 1;
      `);
    } else {
      css.push(`padding-bottom: ${spacing[bottom]};`);
    }
  }

  if (left) {
    //z-index added to keep negative-margin div on top
    if (left.substr(0, 1) === '-') {
      css.push(`
        margin-left: -${spacing[left.substr(1)]};
        z-index: 1;
      `);
    } else {
      css.push(`padding-left: ${spacing[left]};`);
    }
  }

  if (right) {
    //z-index added to keep negative-margin div on top
    if (right.substr(0, 1) === '-') {
      css.push(`
        margin-right: -${spacing[right.substr(1)]};
        z-index: 1;
      `);
    } else {
      css.push(`padding-right: ${spacing[right]};`);
    }
  }

  if (radius) {
    css.push(`border-radius: ${radii[radius]};`);
  }

  return css.join('');
}

export const Column = styled.div.withConfig({
  displayName: "grid__Column",
  componentId: "sc-1yrlhnn-2"
})(["padding:1rem;position:relative;scroll-margin-top:", "px;text-align:center;width:100%;> *:last-child{margin-bottom:0;> *:last-child{margin-bottom:0;}}", " ", " ", ";", ";", " @media (min-width:", "px){", "}@media (min-width:", "px){", "}@media (min-width:", "px){", "}@media (min-width:", "px){", "}"], scrollMargin.top, ({
  background
}) => background && `background: ${background};`, ({
  color
}) => color && `color: ${color};`, ({
  linkColor
}) => linkColor && `a { color: ${linkColor}; }`, ({
  linkHoverColor
}) => linkHoverColor && `a:hover { color: ${linkHoverColor}; }`, ({
  xs
}) => xs && breakpointToCSS(xs), breakpoints.sm, ({
  sm
}) => sm && breakpointToCSS(sm), breakpoints.md, ({
  md
}) => md && breakpointToCSS(md), breakpoints.lg, ({
  lg
}) => lg && breakpointToCSS(lg), breakpoints.xl, ({
  xl
}) => xl && breakpointToCSS(xl));